module.exports = __webpack_public_path__ + "static/boots_of_striding_and_springing-1527af93d5ac6437bab50fcc4c723e0c.jpeg";